import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { A11yModule } from '@angular/cdk/a11y';
import { PlatformModule } from '@angular/cdk/platform';
import { MinDirective } from '@nha/components/forms/validation/minValue.directive';
import { MaxDirective } from '@nha/components/forms/validation/maxValue.directive';

@NgModule({
	imports: [
		CommonModule,
		PlatformModule,
		ReactiveFormsModule,
		FormsModule,
		MatButtonModule,
		MatInputModule,
		MatSelectModule,
		MatIconModule,
		MatCardModule,
		ScrollingModule,
		A11yModule,
		MinDirective,
		MaxDirective
	],
	exports: [MinDirective, MaxDirective]
})
export class NHAFormsModule {}
